// apps/pwa-pos/src/lib/sales.ts
// Sprint 33 — Refactor: usa sync-queue (localStorage) en vez de PowerSync db.
// Sprint 37 — impresión configurable (Fase 1) + payload con pagos/cliente
//              para fiado y métodos múltiples (Fase 2).

import { roundMoney } from '@mibodega/domain';
import { printThermalTicket, type TicketData } from './ticket';
import { encolarVentaOffline } from './sync-queue';
import type { PagoVenta } from './payments';

export interface CartLine {
  productoId: string;
  productoNombre: string;
  presentacionId: string;
  presentacionNombre: string;
  cantidad: number;
  precioUnitario: number;
  subtotal: number;
}

export interface RegistrarVentaInput {
  organizationId: string;
  sucursalId: string;
  monedaCodigo: string;
  /** Sprint 37 — IGTF fuera de la UI; se conserva la firma por compat. */
  aplicaIgtf: boolean;
  lineas: CartLine[];
  /** Sprint 37 — si true, abre la ventana de impresión del ticket. Default false. */
  imprimir?: boolean;
  /** Sprint 37 Fase 2 — pagos que cubren el total. Siempre >= 1. */
  pagos: PagoVenta[];
  /** ID del cliente si es_credito=true; null en el resto. */
  clienteId: string | null;
  /** true sólo cuando el método incluye CREDITO. */
  esCredito: boolean;
}

export async function registrarVentaOffline(input: RegistrarVentaInput): Promise<{
  ventaId: string;
  consecutivo: string;
  total: number;
}> {
  if (input.lineas.length === 0) {
    throw new Error('La venta debe tener al menos un producto');
  }
  if (input.pagos.length === 0) {
    throw new Error('La venta debe tener al menos un pago');
  }

  const result = await encolarVentaOffline(input);

  if (input.imprimir) {
    const subtotal = roundMoney(input.lineas.reduce((acc, l) => acc + l.subtotal, 0));

    const ticketData: TicketData = {
      codigoVenta: result.consecutivo,
      fecha: new Date().toISOString(),
      monedaCodigo: input.monedaCodigo,
      items: input.lineas.map((l) => ({
        nombre: `${l.productoNombre} (${l.presentacionNombre})`,
        cantidad: l.cantidad,
        precioUnitario: l.precioUnitario,
        subtotal: l.subtotal,
      })),
      subtotal,
      total: result.total,
    };

    printThermalTicket(ticketData);
  }

  return result;
}
